/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualOwnFundDto } from '../../models/backend-actual-own-fund-dto';

export interface MonitoringActualsOwnFundCopyCreate$Params {
  id: number;
}

export function monitoringActualsOwnFundCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsOwnFundCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsOwnFundCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualOwnFundDto>;
    }),
  );
}

monitoringActualsOwnFundCopyCreate.PATH = '/api/monitoring/actuals/own-fund/copy/{id}/';
